import { StarIcon } from '@hugeicons/core-free-icons';
import { useTranslation } from 'react-i18next';

import { IconButton } from 'components/IconButton/IconButton';

export const SavedViewDefaultToggle = ({ viewId, isDefault, onSetDefault, small = true }) => {
  const { t } = useTranslation();

  return (
    <IconButton
      icon={StarIcon}
      prefix="hugeicons"
      tip={isDefault ? t('reporting.removeDefault') : t('reporting.setAsDefault')}
      active={isDefault}
      small={small}
      onClick={async () => {
        if (viewId == null) return;
        try {
          await onSetDefault?.(viewId, !isDefault);
        } catch {
          // Toggle failed
        }
      }}
    />
  );
};
